import React from "react";

import "./ProjectCard.css";
import ProjectCardInfo from "./ProjectCardInfo";
import ProjectCardData from "./ProjectCardData";
import { FaGithub } from "react-icons/fa";
import { Link } from "react-router-dom";

const ProjectCard = () => {
  return (
    <div className="card-container">
      <h1 className="card-heading">Recent Projects</h1>
      <div className="projects-container">
        {ProjectCardData.map((project) => {
          return (
            <ProjectCardInfo
              key={project.id}
              id={project.id}
              imgSrc={project.imgSrc}
              title={project.title}
              view={project.view}
              text={project.text}
              gitHub={project.gitHub}
            />
          );
        })}
      </div>
     <Link className="linkk" to="https://github.com/davey2000">
     <button className="but">
     <h3>View More on my Github</h3>
     <FaGithub className="github" size={40}  />
     </button>
     </Link> 
    </div>
  );
};

export default ProjectCard;
